import React, { useState, useEffect, useRef, useCallback } from "react";
import { useHistory, useParams } from "react-router-dom";
import { InputGroup, Form } from "react-bootstrap";
import { CaretDown, PencilSimple, XCircle } from "phosphor-react";
import PhoneInput from "react-phone-input-2";
import Select from "react-select";
import axios from "axios";
import swal from "sweetalert";
import { useReactToPrint } from "react-to-print";
import { Controller, useForm } from "react-hook-form";
import { MoonLoader } from "react-spinners";

// Custom Components
import RequiredLabel from "../CustomCommons/RequiredLabel";
import DoIcon from "../CustomCommons/DoIcon";
import Loader from "../CustomCommons/Loader";
import SelectPagginationEdit from "../Const/SelectPagginationEdit";
import CreateWithPathao from "./Pathao/CreateWithPathao";
import PreviewEdit from "./PreviewEdit";

// Utils and Constants
import { showToast } from "../../utils/ToastHelper";
import { handleInputs } from "../../utils/HandleInputs";
import { BASE_URL } from "../Const/Url";
import * as path from "../Routes/RoutePaths";
import divisions from "../../assets/json/bd_divisions.json";

// Styles
import "./invoice.css";

// Constants
const delivery_charge = {
  0: 80,
  1: 150,
};

const invoice_choices = [
  { value: 0, label: "Recieved" },
  { value: 1, label: "Pending" },
  { value: 2, label: "Refunded" },
  { value: 3, label: "Exchanged" },
];

const delivery_choices = [
  { value: 0, label: "Returned" },
  { value: 1, label: "Order Placed" },
  { value: 2, label: "Delivered" },
  { value: 3, label: "Pending" },
  { value: 4, label: "Hold" },
  { value: 5, label: "Dispatched" },
];

const paymentType = [
  { value: 0, label: "Cash On Delivery" },
  { value: 1, label: "Card" },
  { value: 2, label: "Bank Transfer" },
  { value: 3, label: "Bkash" },
  { value: 4, label: "SSLECOMMERZ" },
  { value: 5, label: "Nagad" },
  { value: 6, label: "Kaaruj Delivery" },
];

const EditInvoice = () => {
  // State Hooks
  const [invoiceLoader, setInvoiceLoader] = useState(false);
  const [customCharge, setCustomCharge] = useState(80);
  const [deleted, setDeleted] = useState([]);
  const { id } = useParams();
  const [sInvoice, setSInvoice] = useState({});
  const [isLoading, setIsLoading] = useState(true);
  const [Found, setFound] = useState(false);
  const [FoundCustomer, setFoundCustomer] = useState({});
  
  // Address related states
  const [selectedDivision, setSelectedDivision] = useState({ label: "", value: "" });
  const [selectedDistrict, setSelectedDistrict] = useState({ label: "", value: "" });
  const [selectedTown, setSelectedTown] = useState({ label: "", value: "" });
  const [selectLoading, setSelectLoading] = useState(false);
  const [districtList, setDistrictList] = useState([]);
  const [upazillaList, setUpazillaList] = useState([]);
  
  // Pathao related states
  const [deliveryService, setDeliveryService] = useState({ label: "Pathao", value: 0 });
  const [pathaoCity, setPathaoCity] = useState({ label: "", value: "" });
  const [pathaoZone, setPathaoZone] = useState({ label: "", value: "" });
  const [pathaoArea, setPathaoArea] = useState({ label: "", value: "" });
  
  // Form and invoice data
  const { register, control, watch, reset, handleSubmit, setValue, formState: { errors } } = useForm();
  
  // Move watchFields inside the component after useForm is initialized
  const watchFields = watch([ "division", "district", "town", "zip"]);
  
  
  const [InvoiceAllData, setInvoiceAllData] = useState({});
  const [paymentAllData, setPaymentAllData] = useState({});
  const [fromCode, setFromCode] = useState("880");
  const [toCode, setToCode] = useState("880");
  const [mainState, setMainState] = useState({});
  const [exchanged, setExchanged] = useState([]);
  const [mainInnerState, setMainInnerState] = useState({});
  const [pS, setPs] = useState(0);
  const [Jdata, setJData] = useState([]);
  const [inputQuery, setInputQuery] = useState("");
  const [URL, setURL] = useState("");
  const [Signature, setSignature] = useState(null);
  const [ProductsList, setProductsList] = useState([]);
  
  // Status states
  const [invoice_status, setInvoiceStatus] = useState(0);
  const [Delivery_status, setDeliveryStatus] = useState(0);
  const [invoice_delivery_type, setInvoiceDeliveryType] = useState(0);
  const [invoice_payment_type, setInvoicePaymentType] = useState(0);
  const [invoice_delivery_charge, setInvoiceDeliveryCharge] = useState(2);
  const [invoice_discount_type, setInvoiceDiscountType] = useState(0);
  
  // Financial states
  const [paid, setPaid] = useState(0);
  const [Discount, setDiscount] = useState(0);
  const [exArray, setExarray] = useState([]);

  // Refs
  const print = useRef();
  const history = useHistory();

  const getAllVariantName = useCallback(() => {
  return mainInnerState && [].concat(
    ...Object.values(mainInnerState).map(a => a.map(b => b.label))
  );
}, [mainInnerState]);

  // Helper functions
  const validateEmail = (email) => /\S+@\S+\.\S+/.test(email);
  const convertData = (date) => new Date(date).toISOString().substring(0, 10);

  // Memoized calculations
  const getSubTotal = useCallback(() => {
    
    const allarray = Object.values(mainState).map(
      curr => curr.variant?.map(variants =>
        getAllVariantName().includes(variants.name) ? parseInt(variants.total) : 0
      ).reduce((a, b) => a + b, 0) || 0
    );
    return allarray.reduce((a, b) => a + b, 0);
  }, [mainState]);

  const getFlatDiscount = () => Discount;
  const getPercentageDiscount = () => parseInt((Discount / 100) * getSubTotal());
  const getDeliveryCharge = () => invoice_delivery_charge === 2 ? customCharge : delivery_charge[invoice_delivery_charge];
  
  const getGrandTotal = useCallback(() => {
    const discountCalc = invoice_discount_type == 0 ? getFlatDiscount() : getPercentageDiscount();
    const charge = parseInt(getDeliveryCharge());
    const grand = getSubTotal() + Math.max(charge, 0) - discountCalc;
    return Math.max(0, parseInt(grand));
  }, [getSubTotal, getDeliveryCharge, invoice_discount_type]);

  const getDueAmount = () => Math.max(0, getGrandTotal() - paid);

  // Data transformation functions
  // const transformData = useCallback((inputData) => {
  //   const transformedData = {};
  //   for (const key in inputData) {
  //     transformedData[`${key} [[${inputData[key][0].product_sku}]]`] = 
  //       inputData[key].map(item => ({
  //         label: item.variant_details.name,
  //         value: item.variant,
  //         price: item.variant_details.price,
  //         stock: item.variant_details.stock,
  //         quantity: item.quantity
  //       }));
  //   }
  //   console.log("transformedData", transformedData);
  //   return transformedData;
  // }, []);

  const transformData = (products) => {
    return products.reduce((result, product) => {
        const productName = product.product_name;
        const variantData = {
            label: product.variant_name,
            value: product.variant,
            price: product.variantObj.price,
            stock: product.variantObj.stock,
            quantity: product.quantity
        };
        
        if (!result[productName]) {
            result[productName] = [];
        }
        
        result[productName].push(variantData);
        return result;
    }, {});
};


  const formatInvoiceProducts = (products) => { 
    const result = {};
    
    products.forEach(item => {
        const productName = item.product_name;
        
        if (!result[productName]) {
            result[productName] = {
                id: item.product,
                variant: [],
                variantObj: {},
                price: parseFloat(item.total), 
                stock: item.variantObj.stock,
                thumb: item.thumb.replace('_optimized', ''), 
                discount: parseFloat(item.discount_value) || 0 
            };
        }
        
        const variant = {
            id: item.variant,
            name: item.variant_name,
            price: parseFloat(item.variantObj.price),
            stock: item.variantObj.stock,
            quantity: item.quantity.toString(),
            total: parseFloat(item.total)
        };
        
        const variantExists = result[productName].variant.some(v => v.id === variant.id);
        if (!variantExists) {
            result[productName].variant.push(variant);
        }
        if (!result[productName].variantObj[item.variant_name]) {
            result[productName].variantObj[item.variant_name] = variant;
        }
    });
    return result;
};

  const formatInv = useCallback((inputData) => {
    const formattedData = [];
    for (const key in inputData) {
      const product = inputData[key];
      product.variant?.forEach(variant => {
        if (parseInt(variant.quantity) >= 0) {
          formattedData.push({
            quantity: variant.quantity,
            total: variant.total.toString(),
            product_name: key.trim(),
            variant_name: variant.name,
            is_custom: false,
            created_at: new Date(),
            invoice_date: InvoiceAllData.invoice_date,
            product: product.id,
            variant: variant.id,
            id: sInvoice?.invoice_products?.find(data => product.id === data?.product)?.id,
            is_regular: true,
          });
        }
      });
    }
    return formattedData;
  }, [InvoiceAllData, sInvoice]);

  // API calls
  const getProductList = useCallback(() => {
    if (inputQuery?.length > 1) {
      const url = inputQuery 
        ? `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice/?query=${inputQuery}`
        : `${BASE_URL}/api/v1/inventory/inventory/product_list_for_invoice/`;

      axios.get(url)
        .then(res => {
          const options = res.data.data.map(curr => ({
            label: `${curr.name} [[${curr?.sku}]]`,
            value: curr.id,
            price: curr.price,
            discount: curr.discount,
            stock: curr.stock,
            variant: curr.variants,
            thumb: curr.thumb_url,
          }));
          setProductsList(options);
        })
        .catch(err => console.error(err));
    }
  }, [inputQuery]);

  const getInvoice = useCallback(() => {
    console.log('getInvoicetest');
    
    axios.get(`${BASE_URL}api/v1/sales/inventory/invoice/${id}`)
      .then(res => {
        if (res.data.status) {
          const data = res.data.data;
          setSInvoice(data);
          setExchanged(data.invoice_products);
          
          const invoiceData = {
            invoice_date: data.invoice_date,
            invoice_due_date: data.due_date,
            invoice_bill_from: data.bill_from,
            invoice_bill_to: data.bill_to,
            invoice_from_mobile: data.from_mobile?.replace("+880", ""),
            invoice_to_mobile: data.to_mobile?.replace("+880", ""),
            invoice_from_address: data.from_address,
            invoice_to_address: data.to_address,
            invoice_delivery_charge: data.delivery_charge_type,
            invoice_delivery_status: data.delivery_status,
            invoice_payment_status: data.payment_status,
            invoice_notes: data.notes,
            invoice_to_email: data?.to_email,
            invoice_from_email: data?.from_email,
            invoice_number: data?.number,
            invoice_barcode: data?.barcode_text,
            barcode: data?.barcode,
            invoice_to_address2: data.to_address2,
            to_zip_code: data.to_zip_code,
            to_country: data.to_country,
            to_district: data.to_district,
            to_division: data.to_division,
            to_city: data.to_city,
          };

          setInvoiceAllData(invoiceData);
          setSignature(data?.signature);
          setURL(data?.signature);
          setPaid(data?.total_paid);
          setDiscount(data?.total_discount);
          setInvoiceDiscountType(data?.discount_type);
          setInvoicePaymentType(data?.payment_type);
          // setMainState(JSON.parse(data.product_list_json).mainstate);
          setMainState(formatInvoiceProducts(data.invoice_products));
          // console.log("data.invoice_products", data.invoice_products);
          
          // setMainInnerState(transformData(data?.invoice_products_formatted));
          setMainInnerState(transformData(data?.invoice_products));
          setInvoiceDeliveryType(data?.delivery_type);
          setDeliveryStatus(data?.delivery_status);
          setCustomCharge(Number(data?.delivery_charge));

          setPaymentAllData({
            card_holder_name: data?.card_holder_name,
            card_number: data?.card_number,
            bank_name: data?.bank_name,
            banK_account_number: data?.banK_account_number,
            banK_account_name: data?.banK_account_name,
            banK_branch_name: data?.banK_branch_name,
            bkash_number: data?.bkash_number,
            bkash_trx_number: data?.bkash_trx_number,
            nagad_number: data?.nagad_number,
            nagad_trx_number: data?.nagad_trx_number,
            reference_id: data?.reference_id,
          });

          setDeliveryService(data.delivery_service === 0 
            ? { label: "Pathao", value: 0 } 
            : { label: "Others", value: 1 });

          setPathaoCity({
            label: data.pathao_city_name || "",
            value: data.pathao_city_id === 0 ? "" : data.pathao_city_id,
          });

          setPathaoZone({
            label: data.pathao_zone_name || "",
            value: data.pathao_zone_id === 0 ? "" : data.pathao_zone_id,
          });

          setPathaoArea({
            label: data.pathao_area_name || "",
            value: data.pathao_area_id === 0 ? "" : data.pathao_area_id,
          });

          setIsLoading(false);
        }
      })
      .catch(err => {
        const errorData = JSON.parse(err.request.response);
        for (let key in errorData.errors) {
          showToast("error", `${key}: ${errorData.errors[key][0]}`);
        }
        showToast("error", errorData.message);
      });
  }, [id]);

  const postInvoice = useCallback((sendEmail) => {
    const url = `${BASE_URL}api/v1/sales/inventory/invoice/${id}/`;
    const current_user = JSON.parse(localStorage.getItem("userData"));
    const toMobile = `+${toCode}${InvoiceAllData.invoice_to_mobile}`;
    const fromMobile = `+${toCode}${InvoiceAllData.invoice_from_mobile}`;
    
    const dataObj = {
      invoice_date: convertData(InvoiceAllData.invoice_date),
      bill_from: InvoiceAllData.invoice_bill_from,
      bill_to: InvoiceAllData.invoice_bill_to,
      from_mobile: fromMobile,
      to_mobile: toMobile,
      to_email: InvoiceAllData.invoice_to_email,
      from_address: InvoiceAllData.invoice_from_address,
      to_address: Found ? FoundCustomer.to_address : InvoiceAllData.invoice_to_address,
      delivery_charge: invoice_delivery_charge === 2 ? customCharge : delivery_charge[invoice_delivery_charge],
      delivery_charge_type: parseInt(invoice_delivery_charge),
      delivery_status: Delivery_status,
      delivery_type: invoice_delivery_type,
      discount_type: invoice_discount_type,
      total_discount: Discount,
      payment_type: invoice_payment_type,
      ...paymentAllData,
      payment_status: invoice_status,
      total_due: parseInt(getDueAmount()),
      sub_total: isNaN(getSubTotal()) ? 0 : getSubTotal(),
      total_paid: paid,
      total_amount: parseInt(getGrandTotal()),
      total_vat: 0,
      notes: InvoiceAllData.invoice_notes,
      created_by: current_user.id,
      send_pdf: sendEmail,
      product_list_json: JSON.stringify({ mainstate: mainState, maininnerstate: mainInnerState }),
      invoice_view_json: JSON.stringify(Jdata),
      invoice_products_details: formatInv(mainState),
      to_address2: Found ? FoundCustomer.to_address2 : InvoiceAllData.invoice_to_address2,
      to_country: Found ? FoundCustomer.to_country : InvoiceAllData.to_country,
      to_district: Found ? FoundCustomer.to_district : watchFields[1]?.label,
      to_division: Found ? FoundCustomer.to_division : watchFields[0]?.label,
      to_zip_code: Found ? FoundCustomer.to_zip_code : watchFields[3],
      to_city: Found ? FoundCustomer.to_city : watchFields[2]?.label,
      exchange_products_json: { data: exArray },
      is_regular: true,
      redex_division: watchFields[0]?.value,
      redex_district: watchFields[1]?.value,
      redex_area: watchFields[2]?.value,
      delivery_service: deliveryService.value,
      pathao_city_name: pathaoCity.label || "",
      pathao_city_id: pathaoCity.value || 0,
      pathao_zone_name: pathaoZone.label || "",
      pathao_zone_id: pathaoZone.value || 0,
      pathao_area_name: pathaoArea.label || "",
      pathao_area_id: pathaoArea.value || 0,
    };

    setInvoiceLoader(true);
    axios.patch(url, dataObj)
      .then(res => {
        if (res.data.status) {
          showToast("success", "Invoice Updated.");
          history.push(path.invoice_list);
        }
      })
      .catch(err => {
        const errorData = JSON.parse(err.request.response);
        for (let key in errorData.errors) {
          showToast("error", `${key}: ${errorData.errors[key][0]}`);
        }
        showToast("error", errorData.message);
      })
      .finally(() => setInvoiceLoader(false));
  }, [id, InvoiceAllData, mainState, mainInnerState, Jdata, exArray, deliveryService, pathaoCity, pathaoZone, pathaoArea, getSubTotal, getGrandTotal, getDueAmount, formatInv]);

  // Effects
  useEffect(() => {
    getInvoice();
  }, [getInvoice]);

  useEffect(() => {
    getProductList();
  }, [inputQuery, getProductList]);

  useEffect(() => {
    if (selectedDivision.value) {
      axios.get(`${BASE_URL}/api/v1/utility/admin/redex-address/${selectedDivision.value}/`)
        .then(response => {
          setDistrictList(response.data.data.districts || []);
        });
    }
  }, [selectedDivision]);

  useEffect(() => {
    if (selectedDistrict.value) {
      const foundAreas = districtList.find(({ id }) => id == selectedDistrict.value)?.areas;
      setUpazillaList(foundAreas || []);
    }
  }, [selectedDistrict, districtList]);

  useEffect(() => {
    if (Object.keys(sInvoice).length !== 0) {
      console.log('sInvoice.to_zip_code', sInvoice.to_zip_code,);
      const addressFields = sInvoice.redex_division_details 
        ? {
            division: { label: sInvoice.redex_division_details.name, value: sInvoice.redex_division_details.id },
            district: { label: sInvoice.redex_district_details.name, value: sInvoice.redex_district_details.id },
            town: { label: sInvoice.redex_area_details.name, value: sInvoice.redex_area_details.id },
            zip: sInvoice.to_zip_code,
          }
        : {
            division: { label: sInvoice.to_division, value: "" },
            district: { label: sInvoice.to_district, value: "" },
            town: { label: sInvoice.to_city, value: "" },
            zip: sInvoice.to_zip_code,
          };

      reset(addressFields);
      setSelectedDivision(addressFields.division);
      setSelectedDistrict(addressFields.district);
      setSelectedTown(addressFields.town);
    }
  }, [sInvoice, reset]);

  useEffect(() => {
    const output = [];
    for (let i in mainState) {
      for (let j in mainState[i].variantObj) {
        const d = mainState[i].variantObj[j];
        if (d.total !== 0) {
          output.push({
            name: i,
            basePrice: mainState[i].price,
            thumb: mainState[i].thumb,
            discount: mainState[i].discount,
            price: d.price,
            quantity: d.quantity,
            id: d.id,
            total: d.total,
            variant: d.name,
          });
        }
      }
    }
    setJData(output);
  }, [mainState]);

  useEffect(() => {
    const data = exchanged.filter(item => deleted.includes(item.product_name)).map(item => item.id);
    setExarray(data);
  }, [mainState, deleted, exchanged]);

  // Handlers
  const handleDivisionChange = (division) => {
    if (division?.value) {
      setSelectedDistrict({ label: "", value: "" });
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setDistrictList([]);
      setSelectLoading(true);
      setCustomCharge(0);
      setSelectedDivision(division);
      setValue("division", division);
    }
  };

  const handleDistrictChange = (district) => {
    if (district?.value) {
      setSelectedTown({ label: "", value: "" });
      setValue("zip", "");
      setUpazillaList([]);
      setSelectLoading(false);
      setCustomCharge(0);
      setSelectedDistrict(district);
      setValue("district", district);
    }
  };

  const handleTownChange = (town) => {
    if (town?.value) {
      setValue("zip", "");
      setSelectedTown(town);
      setValue("town", town);
      const foundDeliveryCharge = upazillaList.find(({ id }) => id == town.value)?.delivery_charge;
      if (foundDeliveryCharge) {
        setCustomCharge(Number(foundDeliveryCharge));
        setInvoiceDeliveryCharge(2);
      }
    }
  };
  const handleInnerVariant = (currentName, value) => {
    setMainInnerState(prev => ({ ...prev, [currentName]: value }));
  };

  const handleMultiInputChange = (newValue, actionMeta) => {
    if (actionMeta.action === "select-option") {
      const option = actionMeta.option;
      const variantsObj = {};
      option.variant.forEach(curr => {
        variantsObj[curr.name] = {
          id: curr.id,
          name: curr.name,
          price: curr.price,
          stock: curr.stock,
          product: option.value,
          quantity: -1,
          total: 0,
        };
      });

      setMainState(prev => ({
        ...prev,
        [option.label]: {
          id: option.value,
          variant: option.variant.map(curr => ({
            id: curr.id,
            name: curr.name,
            price: curr.price,
            stock: curr.stock,
            product: option.value,
            quantity: -1,
            total: 0,
          })),
          variantObj: variantsObj,
          price: parseInt(option.price),
          stock: parseInt(option.stock),
          thumb: option.thumb,
          discount: parseInt(option.discount),
        },
      }));
    }

    if (actionMeta.action === "remove-value") {
      const removedLabel = actionMeta.removedValue.label;
      setDeleted(prev => [...prev, removedLabel]);
      setMainState(prev => {
        const newState = { ...prev };
        delete newState[removedLabel];
        return newState;
      });
      setMainInnerState(prev => {
        const newState = { ...prev };
        delete newState[removedLabel];
        return newState;
      });
    }
  };

  const handlePrint = useReactToPrint({
    content: () => print.current,
    documentTitle: "emp-data",
    bodyClass: "dis",
  });

  const handlePrint2 = () => {
    if (InvoiceAllData.invoice_from_email || InvoiceAllData.invoice_to_email || 
        InvoiceAllData.invoice_bill_to || InvoiceAllData.invoice_bill_form) {
      handlePrint();
    } else {
      swal("error");
    }
  };

  const ValidateData = (sendEmail) => {
    const bd = /^[1][0-9]{9}$/;
    const errors = [];

    if (!InvoiceAllData.invoice_date) errors.push("Issue Date can't be empty");
    if (!bd.test(InvoiceAllData.invoice_from_mobile?.replace("+880", ""))) {
      errors.push("From Mobile: Please Enter Valid phone number");
    }
    if (!bd.test(InvoiceAllData.invoice_to_mobile?.replace("+880", ""))) {
      errors.push("To Mobile: Please Enter Valid phone number");
    }
    if (!Found && !InvoiceAllData.invoice_bill_from) errors.push("Bill from can't be empty");
    if (!Found && !InvoiceAllData.invoice_bill_to) errors.push("Bill to can't be empty");
    if (!InvoiceAllData.invoice_from_email) errors.push("From email can't be empty");
    if (!validateEmail(InvoiceAllData.invoice_from_email)) errors.push("From email not valid");
    if (InvoiceAllData.invoice_to_email && !validateEmail(InvoiceAllData.invoice_to_email)) {
      errors.push("To email not valid");
    }
    if (!Found && !InvoiceAllData.invoice_to_address) errors.push("To address can't be empty");
    if (Object.keys(mainState).length <= 0) errors.push("Product Details is empty");

    if (deliveryService.value === 1) {
      if (!watchFields[0]?.label && !FoundCustomer.to_division) errors.push("Division is empty");
      if (!watchFields[1]?.label && !FoundCustomer.to_district) errors.push("District is empty");
      if (!watchFields[2]?.label && !FoundCustomer.to_city) errors.push("City is empty");
    }

    if (deliveryService.value === 0) {
      if (!pathaoCity?.label) errors.push("City is empty");
      if (!pathaoZone?.label) errors.push("Zone is empty");
      if (!pathaoArea?.label) errors.push("Area is empty");
    }

    if (errors.length > 0) {
      errors.forEach(error => showToast("error", error));
      return false;
    }

    postInvoice(sendEmail);
    return true;
  };

  const SaveAndSendEmail = () => ValidateData(true);

  // Component rendering
  if (isLoading) return <Loader />;

  return (
    <div className="categorey-parent">
      {/* Product Details Section */}
      <div className="invoice-b my-4 bg-white cat-child" style={{ borderTop: "0.5px solid #E0E0E0" }}>
        <h4 className="my-2 mb-4 padding-main-head">Product Details</h4>
        <div className="border-p"></div>
        <div className="padding-main">
          <SelectPagginationEdit
            handleMultiInputChange={handleMultiInputChange}
            inputProduct={setInputQuery}
            ProductsList={ProductsList.filter(item => !Object.keys(mainInnerState).includes(item.label))}
            defaultValue={!isLoading && Object.keys(mainState).map((curr, index) => ({
              value: index,
              label: curr,
            }))}
            setProductsList={setProductsList}
            inputQuery={inputQuery}
          />
          
          {/* Product Variant Tables */}
          <div className="mt-3">
            <div className="rounded" style={{ background: "#FAFAFA", display: "block", overflowX: "scroll", width: "100%", msOverflowStyle: "none", scrollbarWidth: "none" }}>
              <table className="item-tables table_my2">
                <tbody>
                  {Object.keys(mainState).map((curr, index) => (
                    <React.Fragment key={index}>
                      <div className="mt-4 px-2" style={{ background: "rgba(245, 245, 245, 0.36)", border: "none", height: "200px", minWidth: "600px", position: "relative", overflow: "visible" }}>
                        {/* Product Header Row */}
                        <div className="row py-3 my-3" style={{ height: "45px" }}>
                          <div className="col-5 minWidthForInvoiceCreateTable ps-4" style={{ textAlign: "start" }}>
                            <p>Product Name</p>
                          </div>
                          <div className="col-2 minWidthForInvoiceCreateTable py-1" style={{ textAlign: "center" }}>
                            Total Stock
                          </div>
                          <div className="col-5 minWidthForInvoiceCreateTable py-1" style={{ textAlign: "center" }}>
                            Variants
                          </div>
                        </div>

                        {/* Product Details Row */}
                        <div className="row" style={{ height: "45px" }}>
                          <div className="col-5 ps-4 py-1 d-flex align-items-center">
                            <p className="text-capitalize">{curr}</p>
                            <img
                              width={50}
                              style={{ margin: "6px 0px !important", border: "0.2px solid #bcb0b0" }}
                              height={50}
                              src={mainState[curr].thumb}
                              alt="product"
                              className="ms-3 shadow-sm"
                            />
                          </div>
                          <div className="col-2 py-1">
                            <p className="text-capitalize text-center d-flex align-items-center justify-content-center">
                              {Number(mainState[curr].stock)}
                            </p>
                          </div>
                          <div className="col-5 text-center py-1 pe-2">
                            <div style={{ marginTop: "-10px" }}>
                              <Select
                                isMulti
                                placeholder="-Select Variants-"
                                isClearable
                                onChange={(value) => handleInnerVariant(curr, value)}
                                defaultValue={mainInnerState[curr]}
                                options={mainState[curr].variantObj && Object.values(mainState[curr].variantObj).map(variant => ({
                                  label: variant.name,
                                  value: variant.id,
                                  price: variant.price,
                                  stock: variant.stock,
                                  quantity: 1,
                                }))}
                              />
                            </div>
                          </div>
                        </div>
                      </div>

                      {/* Variant Table */}
                      <table className="mapTable shadow-sm ms-2">
                        <tbody className="innerTbody w-100">
                          {mainInnerState[curr]?.map((innerCur, idx) => (
                            <React.Fragment key={idx}>
                              {idx === 0 && (
                                <thead style={{ border: "1.5px solid #E0E0E0" }}>
                                  <tr className="px-3" style={{ height: "45px" }}>
                                    <th className="minWidthForInvoiceCreateTable ps-4" style={{ width: "349px", textAlign: "start" }}>Variant</th>
                                    <th className="minWidthForInvoiceCreateTable py-3" style={{ width: "150px", textAlign: "center" }}>Price</th>
                                    <th className="minWidthForInvoiceCreateTable py-3" style={{ width: "150px", textAlign: "center" }}>In Stock</th>
                                    <th className="minWidthForInvoiceCreateTable py-3" style={{ width: "150px", textAlign: "center" }}>Quantity</th>
                                    <th className="minWidthForInvoiceCreateTable py-3" style={{ width: "150px", textAlign: "center" }}>Total</th>
                                  </tr>
                                </thead>
                              )}
                              <tbody>
                                <tr className="border-invoice" style={{ height: "45px" }}>
                                  <td className="ps-4 py-3">
                                    <p className="text-capitalize">{innerCur.label}</p>
                                  </td>
                                  <td className="text-center py-3" style={{ minWidth: "300px" }}>
                                    <input
                                      value={mainState[curr].discount === 0 
                                        ? mainState[curr].price + parseInt(innerCur.price)
                                        : mainState[curr].discount + parseInt(innerCur.price)}
                                      className="invoiceCreateSmallInputs"
                                      placeholder="00.00"
                                      type="text"
                                    />
                                  </td>
                                  <td className="text-center py-3">
                                    <input
                                      value={innerCur.stock}
                                      className="invoiceCreateSmallInputs"
                                      placeholder="00.00"
                                      type="text"
                                    />
                                  </td>
                                  <td className="text-center py-3">
                                    <input
                                      type="number"
                                      onWheel={(e) => e.target.blur()}
                                      onChange={(e) => {
                                        const value = Math.max(0, parseInt(e.target.value));
                                        const productName = curr;
                                        const variantName = innerCur.label;
                                        
                                        setMainState(prev => {
                                          const newState = { ...prev };
                                          const variantKey = Object.keys(newState[productName].variant).find(
                                            key => newState[productName].variant[key].name === variantName
                                          );
                                          
                                          if (value > innerCur.stock) {
                                            showToast("error", `Max Stock: ${innerCur.stock}`);
                                            newState[productName].variant[variantKey].quantity = innerCur.stock;
                                            newState[productName].variantObj[variantName].quantity = innerCur.stock;
                                          } else {
                                            newState[productName].variant[variantKey].quantity = value;
                                            newState[productName].variantObj[variantName].quantity = value;
                                          }
                                          
                                          const discountPrice = newState[productName].discount === 0 
                                            ? newState[productName].price 
                                            : newState[productName].discount;
                                          
                                          newState[productName].variant[variantKey].total = 
                                            newState[productName].variant[variantKey].quantity * 
                                            (discountPrice + parseInt(newState[productName].variant[variantKey].price));
                                          
                                          newState[productName].variantObj[variantName].total = 
                                            newState[productName].variantObj[variantName].quantity * 
                                            (discountPrice + parseInt(newState[productName].variantObj[variantName].price));
                                          
                                          return newState;
                                        });
                                      }}
                                      className="invoiceCreateSmallInputs"
                                      placeholder="00.00"
                                      value={mainState[curr]?.variantObj?.[innerCur.label]?.quantity === -1 
                                        ? 0 
                                        : mainState[curr]?.variantObj?.[innerCur.label]?.quantity || 0}
                                    />
                                  </td>
                                  <td className="text-center py-3">
                                    <input
                                      value={mainState[curr]?.variantObj?.[innerCur.label]?.total || 0}
                                      className="invoiceCreateSmallInputs"
                                      placeholder="00.00"
                                      type="text"
                                    />
                                  </td>
                                </tr>
                              </tbody>
                            </React.Fragment>
                          ))}
                        </tbody>
                      </table>
                    </React.Fragment>
                  ))}
                </tbody>
              </table>

              {/* Summary Section */}
              <div className="d-flex flex-column flex-md-row mt-4 justify-content-between mx-4">
                <div>
                  <h6>Total Item: {Object.keys(mainState).length}</h6>
                </div>
                <div>
                  <div className="d-flex justify-content-between" style={{ color: "#212121", fontSize: "16px", fontWeight: "bold" }}>
                    <p>Sub Total:</p>
                    <p className="ms-3">
                      <input className="ms-3 invoiceInpCss" type="text" value={isNaN(getSubTotal()) ? 0 : getSubTotal()} readOnly />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between cl">
                    <p>Delivery Charge:</p>
                    <p className="ms-3">
                      <input
                        className="ms-3 invoiceInpCss"
                        onChange={(e) => {
                          const newValue = Number(e.target.value);
                          setCustomCharge(isNaN(newValue) ? 0 : newValue);
                          if (parseInt(invoice_delivery_charge) !== 2) {
                            setInvoiceDeliveryCharge(2);
                          }
                        }}
                        type="number"
                        value={getDeliveryCharge()}
                        style={{ border: "1px solid gray" }}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between pl pt-2">
                    <p>Discount {invoice_discount_type === 0 ? "" : "%"}:</p>
                    <p className="ms-3">
                      <input
                        className="ms-3 invoiceInpCss paid_input_css"
                        type="text"
                        value={Discount}
                        onChange={(e) => setDiscount(e.target.value)}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between" style={{ color: "#212121", fontSize: "16px", fontWeight: "bold" }}>
                    <p>Total amount:</p>
                    <p className="ms-3">
                      <input className="ms-3 invoiceInpCss" type="text" value={getGrandTotal() || 0} readOnly />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between pl pt-2">
                    <p>Paid amount:</p>
                    <p className="ms-3">
                      <input
                        className="ms-3 invoiceInpCss paid_input_css"
                        type="text"
                        value={paid}
                        onChange={(e) => setPaid(e.target.value)}
                      />
                    </p>
                  </div>

                  <div className="d-flex justify-content-between cl">
                    <p>Due amount:</p>
                    <p className="ms-3">
                      <input className="ms-3 invoiceInpCss" type="text" value={isNaN(getDueAmount()) ? 0 : getDueAmount()} readOnly />
                    </p>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Invoice Details Section */}
      <div className="bg-white cat-child">
        <div className="d-flex align-items-center" style={{ padding: "20px 24px", border: "0.5px solid #E0E0E0" }}>
          <h3 style={{ fontSize: "23px", marginTop: "6px", marginLeft: "12px" }}>Invoice Details</h3>
        </div>
        
        <div className="product-main createInvoiceInputContainer">
          <div className="row">
            {/* Invoice Number */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Invoice Number" />
              <InputGroup className="mb-3">
                <Form.Control
                  disabled
                  placeholder="Inv00014"
                  value={InvoiceAllData?.invoice_number}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
            
            {/* Barcode */}
            <div className="col-12 col-md-6">
              <p>Barcode</p>
              <InputGroup className="mb-3">
                <Form.Control
                  disabled
                  placeholder="This will be generated automatically"
                  value={InvoiceAllData?.invoice_barcode}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* Invoice Date */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Invoice Date" />
              <div className="position-relative">
                <InputGroup>
                  <Form.Control
                    type="date"
                    style={{ backgroundColor: "#FAFAFA" }}
                    name="invoice_date"
                    value={InvoiceAllData.invoice_date}
                    onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  />
                </InputGroup>
              </div>
            </div>

            {/* Delivery Type */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Delivery Type" />
              <div className="mb-3" style={{ height: "47px" }}>
                <Form.Select
                  value={invoice_delivery_type}
                  onChange={(e) => setInvoiceDeliveryType(e.target.value)}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  <option value={0}>Regular</option>
                  <option value={1}>Urgent</option>
                </Form.Select>
              </div>
            </div>

            {/* From Mobile */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="From Mobile" />
              <div className="d-flex phoneContainer">
                <PhoneInput
                  inputClass="phoneinput"
                  disableDropdown
                  onChange={setFromCode}
                  country={"bd"}
                />
                <div className="w-100">
                  <Form.Control
                    placeholder="Input number"
                    style={{ backgroundColor: "#FAFAFA" }}
                    className="phone_insert_input"
                    name="invoice_from_mobile"
                    value={InvoiceAllData.invoice_from_mobile?.replace("+880", "")}
                    onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  />
                </div>
              </div>
            </div>

            {/* To Mobile */}
            <div className="col-12 col-md-6 mb-3">
              <RequiredLabel text="To Mobile" />
              <div className="d-flex phoneContainer">
                <PhoneInput
                  inputClass="phoneinput"
                  disableDropdown
                  onChange={setFromCode}
                  country={"bd"}
                />
                <div className="w-100">
                  <Form.Control
                    placeholder="Input number"
                    style={{ backgroundColor: "#FAFAFA" }}
                    className="phone_insert_input"
                    name="invoice_to_mobile"
                    value={InvoiceAllData.invoice_to_mobile?.replace("+880", "")}
                    onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  />
                </div>
              </div>
            </div>

            {/* Bill From */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Bill From" />
              <InputGroup className="mb-3">
                <Form.Control
                  name="invoice_bill_from"
                  value={InvoiceAllData.invoice_bill_from}
                  onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* Bill To */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Bill To" />
              <InputGroup className="mb-3">
                <Form.Control
                  name="invoice_bill_to"
                  value={Found ? FoundCustomer.name : InvoiceAllData.invoice_bill_to}
                  onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* Delivery Charge */}
            <div className="col-12 col-md-6 mt-3">
              <RequiredLabel text="Delivery Charge" />
              <div className="mb-3" style={{ height: "47px" }}>
                <Form.Select
                  value={invoice_delivery_charge}
                  onChange={(e) => {
                    const value = Number(e.target.value);
                    setInvoiceDeliveryCharge(value);
                    if (value === 0) setCustomCharge(80);
                    else if (value === 1) setCustomCharge(150);
                  }}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  <option value={0}>Inside Dhaka: 80/-</option>
                  <option value={1}>Outside Dhaka: 150/-</option>
                  <option value={2}>Custom</option>
                </Form.Select>
              </div>
            </div>

            {/* Discount Type */}
            <div className="col-12 col-md-6 mt-3">
              <RequiredLabel text="Discount Type" />
              <div style={{ height: "47px" }}>
                <Form.Select
                  value={invoice_discount_type}
                  onChange={(e) => setInvoiceDiscountType(e.target.value)}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  <option value={0}>Flat</option>
                  <option value={1}>Percentage</option>
                </Form.Select>
              </div>
            </div>

            {/* From Email */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="From Email" />
              <InputGroup className="mb-3">
                <Form.Control
                  name="invoice_from_email"
                  value={InvoiceAllData.invoice_from_email}
                  onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* To Email */}
            <div className="col-12 col-md-6">
              <p>To Email</p>
              <InputGroup className="mb-3">
                <Form.Control
                  name="invoice_to_email"
                  value={InvoiceAllData.invoice_to_email}
                  onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* From Address */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="From Address" />
              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  name="invoice_from_address"
                  value={InvoiceAllData.invoice_from_address}
                  onChange={(e) => handleInputs(e, setInvoiceAllData)}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            <div className="col-12 col-md-6"></div>

            {/* To Address 1 */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="To Address 1" />
              <InputGroup className="addressInput">
                <Form.Control
                  name="invoice_to_address"
                  value={Found ? FoundCustomer.to_address : InvoiceAllData.invoice_to_address}
                  onChange={(e) =>
                    Found
                      ? setFoundCustomer({ ...FoundCustomer, to_address: e.target.value })
                      : handleInputs(e, setInvoiceAllData)
                  }
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* To Address 2 */}
            <div className="col-12 col-md-6">
              <p>To Address 2</p>
              <InputGroup className="addressInput">
                <Form.Control
                  name="invoice_to_address2"
                  value={Found ? FoundCustomer.to_address2 : InvoiceAllData.invoice_to_address2}
                  onChange={(e) =>
                    Found
                      ? setFoundCustomer({ ...FoundCustomer, to_address2: e.target.value })
                      : handleInputs(e, setInvoiceAllData)
                  }
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>

            {/* Delivery Service */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Delivery Service" />
              <Select
                onChange={setDeliveryService}
                options={[
                  { label: "Pathao", value: 0 },
                  { label: "Others", value: 1 },
                ]}
                value={deliveryService}
                placeholder="Select"
                styles={{
                  control: (baseStyles, state) => ({
                    ...baseStyles,
                    borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                    boxShadow: state.isFocused ? "0 0 0px 0.5px rgba(255, 0, 0, 1)" : "none",
                    "&:hover": { borderColor: "#e0e0e0" },
                    maxHeight: "120px",
                    overflowY: "auto",
                  }),
                  multiValueContainer: (baseStyles) => ({
                    ...baseStyles,
                    overflowY: "auto",
                    maxHeight: "120px",
                    display: "flex",
                    flexWrap: "wrap",
                  }),
                }}
              />
            </div>

            {/* Address Fields based on Delivery Service */}
            {deliveryService?.value === 1 ? (
              <>
                <div className="col-12 col-md-6">
                  <RequiredLabel text="To Division" />
                  <Controller
                    name="division"
                    control={control}
                    render={({ field }) => (
                      <Select
                        isSearchable
                        {...field}
                        value={selectedDivision}
                        onChange={handleDivisionChange}
                        options={divisions.map(({ name, id }) => ({ label: name, value: id }))}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                            boxShadow: state.isFocused ? "0 0 0px 0.5px rgba(255, 0, 0, 1)" : "none",
                            "&:hover": { borderColor: "#e0e0e0" },
                            maxHeight: "120px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                    )}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <RequiredLabel text="To District" />
                  <Controller
                    name="district"
                    control={control}
                    render={({ field }) => (
                      <Select
                        isLoading={selectLoading}
                        isSearchable
                        {...field}
                        value={selectedDistrict}
                        onChange={handleDistrictChange}
                        options={districtList?.map(({ name, id }) => ({ label: name, value: id }))}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                            boxShadow: state.isFocused ? "0 0 0px 0.5px rgba(255, 0, 0, 1)" : "none",
                            "&:hover": { borderColor: "#e0e0e0" },
                            maxHeight: "120px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                    )}
                  />
                </div>

                <div className="col-12 col-md-6">
                  <RequiredLabel text="To City" />
                  <Controller
                    name="town"
                    control={control}
                    render={({ field }) => (
                      <Select
                        isSearchable
                        {...field}
                        value={selectedTown}
                        onChange={handleTownChange}
                        options={upazillaList?.map(({ name, id }) => ({ label: name, value: id }))}
                        styles={{
                          control: (baseStyles, state) => ({
                            ...baseStyles,
                            borderColor: state.isFocused ? "#e0e0e0" : "#e0e0e0",
                            boxShadow: state.isFocused ? "0 0 0px 0.5px rgba(255, 0, 0, 1)" : "none",
                            "&:hover": { borderColor: "#e0e0e0" },
                            maxHeight: "120px",
                            overflowY: "auto",
                          }),
                        }}
                      />
                    )}
                  />
                </div>
              </>
            ) : (
              <CreateWithPathao
                pathaoCity={pathaoCity}
                setPathaoCity={setPathaoCity}
                pathaoZone={pathaoZone}
                setPathaoZone={setPathaoZone}
                pathaoArea={pathaoArea}
                setPathaoArea={setPathaoArea}
                mainState={mainState}
                setCustomCharge={setCustomCharge}
                setinvoice_delivery_charge={setInvoiceDeliveryCharge}
                subTotal={parseInt(getGrandTotal()) - customCharge}
              />
            )}

            {/* Post Code */}
            <div className="col-12 col-md-6 mt-2">
              <p>Post Code</p>
              <input style={{ width: "100%" }} type="text" {...register("zip")} />
            </div>

            {/* Payment Type */}
            <div className="col-12 col-md-6">
              <RequiredLabel text="Payment Type" />
              <div className="mb-3">
                <Form.Select
                  size="lg"
                  value={invoice_payment_type}
                  onChange={(e) => setInvoicePaymentType(e.target.value)}
                  style={{
                    backgroundColor: "#FAFAFA",
                    fontSize: "16px",
                    height: "47px",
                    borderRadius: "8px",
                    color: "#828282",
                  }}
                >
                  {paymentType.map((curr) => (
                    <option key={curr.value} value={curr.value}>{curr.label}</option>
                  ))}
                </Form.Select>
              </div>
            </div>

            {/* Reference ID */}
            <div className="col-12 col-md-6">
              <p>Reference ID</p>
              <InputGroup className="mb-3 addressInput">
                <Form.Control
                  name="reference_id"
                  value={paymentAllData.reference_id}
                  onChange={(e) => handleInputs(e, setPaymentAllData)}
                  style={{ backgroundColor: "#FAFAFA" }}
                />
              </InputGroup>
            </div>
          </div>
        </div>
      </div>

      {/* Payment Details Section (Conditional) */}
      {![0, "0", 6, "6"].includes(invoice_payment_type) && (
        <div className="invoice-b my-4 bg-white cat-child" style={{ borderTop: "0.5px solid #E0E0E0" }}>
          <h4 className="my-2 mb-4 padding-main-head">Payment Details</h4>
          <div className="border-p"></div>

          {/* Payment Type Specific Fields */}
          {invoice_payment_type === 5 || invoice_payment_type === "5" ? (
            <div className="padding-main row">
              <div className="col-12 col-md-6">
                <p>Nagad Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="nagad_number"
                    value={paymentAllData.nagad_number}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>TNX Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="nagad_trx_number"
                    value={paymentAllData.nagad_trx_number}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
            </div>
          ) : invoice_payment_type === 3 || invoice_payment_type === "3" ? (
            <div className="padding-main row">
              <div className="col-12 col-md-6">
                <p>BKash Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="bkash_number"
                    value={paymentAllData.bkash_number}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>TNX Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="bkash_trx_number"
                    value={paymentAllData.bkash_trx_number}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
            </div>
          ) : invoice_payment_type === 2 || invoice_payment_type === "2" ? (
            <div className="padding-main row">
              <div className="col-12 col-md-6">
                <p>Bank Name</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="bank_name"
                    value={paymentAllData.bank_name}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>Branch Name</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="banK_branch_name"
                    value={paymentAllData.banK_branch_name}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>Account Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="banK_account_number"
                    value={paymentAllData.banK_account_number}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>Account Name</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="banK_account_name"
                    value={paymentAllData.banK_account_name}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
            </div>
          ) : invoice_payment_type === 1 || invoice_payment_type === "1" ? (
            <div className="padding-main row">
              <div className="col-12 col-md-6">
                <p>Card Number</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="card_number"
                    value={paymentAllData.card_number}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
              <div className="col-12 col-md-6">
                <p>Card Holder Name</p>
                <InputGroup className="mb-3 addressInput">
                  <Form.Control
                    name="card_holder_name"
                    value={paymentAllData.card_holder_name}
                    onChange={(e) => handleInputs(e, setPaymentAllData)}
                    style={{
                      backgroundColor: "#FAFAFA",
                      fontSize: "16px",
                      height: "47px",
                      borderRadius: "8px",
                      color: "#828282",
                    }}
                  />
                </InputGroup>
              </div>
            </div>
          ) : null}
        </div>
      )}

      {/* Status and Notes Section */}
      <div className="product-main my-4 bg-white cat-child" style={{ borderTop: "0.5px solid #E0E0E0" }}>
        <div>
          <p>Payment Status</p>
          <Select
            placeholder="---Select---"
            isClearable
            options={invoice_choices}
            defaultValue={invoice_choices.find(curr => curr.value === invoice_status)}
            onChange={(option) => setInvoiceStatus(option.value)}
          />

          <p className="mt-4">Delivery Status</p>
          <Select
            placeholder="---Select---"
            isClearable
            options={delivery_choices}
            defaultValue={delivery_choices.find(curr => curr.value === Delivery_status)}
            onChange={(option) => setDeliveryStatus(option.value)}
          />

          {/* Notes */}
          <div className="mt-3 d-flex align-content-center">
            <PencilSimple size={12} weight="light" className="mt-0 pe-1" />
            <p style={{ color: "#333333" }} className="mb-2">Notes</p>
          </div>
          <Form.Control
            as="textarea"
            name="invoice_notes"
            value={InvoiceAllData.invoice_notes}
            onChange={(e) => handleInputs(e, setInvoiceAllData)}
            style={{
              height: "100px",
              resize: "none",
              backgroundColor: "#FAFAFA",
            }}
          />
        </div>
      </div>

      {/* Action Buttons */}
      <div className="padding-btn-head mb-4 d-flex justify-content-end bg-white cat-child" style={{ border: "0.5px solid #E0E0E0" }}>
        <div style={{ marginLeft: "-10px" }}>
          <button
            className="btn rounded border align-items-center d-none me-2 mt-2"
            disabled={!InvoiceAllData}
            onClick={handlePrint2}
          >
            <DoIcon className="doc" /> Preview PDF
          </button>

          {invoiceLoader ? (
            <button disabled className="btn rounded border me-2 mt-2">
              <MoonLoader color="black" size={10} /> Creating...
            </button>
          ) : (
            <button
              onClick={() => ValidateData(false)}
              className="btn rounded border me-2 mt-2"
            >
              Save Invoice
            </button>
          )}

          {InvoiceAllData.invoice_to_email && !Found && validateEmail(InvoiceAllData.invoice_to_email) && (
            <button
              onClick={SaveAndSendEmail}
              className="btn rounded border text-white mt-2"
              style={{ background: "black" }}
            >
              Save & Send PDF
            </button>
          )}

          <button
            className="btn rounded border me-2 ms-2 mt-2"
            onClick={() => history.push(path.invoice_list)}
          >
            Cancel
          </button>

          {/* Hidden Preview Component */}
          <div className="d-none">
            <PreviewEdit
              print={print}
              status={invoice_payment_type}
              Found={Found}
              InvoiceAllData={InvoiceAllData}
              FoundCustomer={FoundCustomer}
              mainState={mainState}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditInvoice;